<script setup lang="ts">
import { Button } from '@dashhudson/dashing-ui/button';
import { useSidePanel } from '@dashhudson/dashing-ui/side-panel';
import { useRouter } from 'vue-router';

import { VISION_AI_SUMMARY_INTERACTIONS } from '@/components/VisionAi/constants';
import type {
  RedirectButtonWidgetData,
  VisionAiWidgetClickPayload,
} from '@/components/VisionAi/widgets/visionWidget.types';
import { useVisionAiStore } from '@/stores/vision-ai';

const { widgetData } = defineProps<{
  widgetData: RedirectButtonWidgetData;
  narrowMode?: boolean;
}>();

const emit = defineEmits<{
  onWidgetClick: [payload: VisionAiWidgetClickPayload];
}>();

const router = useRouter();
const visionAiStore = useVisionAiStore();
const { setExpanded } = useSidePanel();

function handleClick() {
  const { pathname, search, hash } = new URL(widgetData.url, window.location.origin);
  const redirectRoute = `${pathname}${search}${hash}`;

  emit('onWidgetClick', {
    interaction: VISION_AI_SUMMARY_INTERACTIONS.REDIRECT_BUTTON_CLICK,
    label: widgetData.label,
    redirectRoute,
  });
  setExpanded(false);
  visionAiStore.setKeepVisionPanelOpen(true);
  router.push(redirectRoute).finally(() => {
    visionAiStore.setKeepVisionPanelOpen(false);
  });
}
</script>

<template>
  <Button
    severity="primary"
    :label="widgetData.label"
    :icon="widgetData.icon"
    data-testid="redirect-button-widget"
    @click="handleClick"
  />
</template>
